import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useUserAuth } from "../../contexts/user.context";
import { getQuestionHistoryDataWithCallId } from '../../utils/firebase/firebase.utils';
import { Alert, Loader, Space, Title, Text, createStyles } from '@mantine/core';
import { beigeColor } from '../../assets/constants';
import ChangeHistoryVisual from "../../components/change-history-visual/change-history-visual.component";
import FormPaper from '../../components/form-paper/form-paper.component';
import { IconAlertCircle } from '@tabler/icons-react';

const useStyles = createStyles((theme) => ({

    outerContainer: {
        background: beigeColor,
        minHeight: '100vh',
        padding: '75px 20px',
        [theme.fn.smallerThan('xs')]: {
            background: 'white',
            padding: '0px',
        }
    },

    formContainer: {
        width: '100%',
        maxWidth: '650px',
        margin: '0px auto',
    },

    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

}));

const filterData = (questions, histories) => {
    const questionsFiltered = {};
    const historiesFiltered = {};
    if (typeof questions !== 'object' || typeof histories !== 'object') return {questionsFiltered, historiesFiltered};
    Object.keys(questions).forEach(id => {
        if (histories[id] && typeof histories[id] === 'object' && histories[id].length > 1) {
            questionsFiltered[id] = questions[id];
            historiesFiltered[id] = histories[id];
        }
    });
    return { questionsFiltered, historiesFiltered };
};

const KeystrokeHistory = () => {

    const { callId, questionId } = useParams();

    const { currentUser } = useUserAuth();

    const [questionHistories, setQuestionHistories] = useState({});
    const [questionText, setQuestionText] = useState({});
    const [orderedKeys, setOrderedKeys] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorLoadingHistory, setErrorLoadingHistory] = useState(null);
    const { classes } = useStyles();

    useEffect(() => {
        const getQuestionHistory = async (callId, questionId) => {
            try {
                setIsLoading(true);
                var { histories, questions } = await getQuestionHistoryDataWithCallId(currentUser, callId, questionId);
                const { questionsFiltered, historiesFiltered } = filterData(questions, histories);
                const keysSorted = Object.keys(historiesFiltered).sort((a, b) => historiesFiltered[a][0].time_since_start - historiesFiltered[b][0].time_since_start);
                setOrderedKeys(keysSorted);
                setQuestionHistories(historiesFiltered);
                setQuestionText(questionsFiltered);
            } catch (error) {
                setErrorLoadingHistory(true);
                console.log('error', error)
            }
            setIsLoading(false);
        };
        getQuestionHistory(callId, questionId);
    }, []);

    return (
        <div className={classes.outerContainer}>
            <div className={classes.formContainer}>
                <FormPaper>
                    <Title order={3} weight={500}>Text Change Visualizer</Title>
                    <Space h={5} />
                    <Text>
                        This visualizer replays the recorded keystroke history for a recorded open-ended question. It shows the text as it was typed, character by character, and the time taken to type each character.
                    </Text>
                    <Space h='xl' />
                    {
                        isLoading
                            ?
                            <div className={classes.loaderContainer}>
                                <Loader size='sm' />
                            </div>
                            :
                            errorLoadingHistory || orderedKeys.length === 0
                                ?
                                <Alert
                                    icon={<IconAlertCircle size="18px"
                                        stroke='1.75px' />}
                                    title="History not found"
                                    color="red"
                                    radius='md'
                                >
                                    Please reload the page or contact support if the issue persists.
                                </Alert>
                                :
                                orderedKeys.map((questionId, index) => (
                                    questionHistories[questionId].length > 1 &&
                                    <ChangeHistoryVisual
                                        key={index}
                                        questionHistory={questionHistories[questionId]}
                                        questionText={questionText[questionId]}
                                        questionId={questionId}
                                        isLast = {index === Object.keys(questionHistories).length - 1}
                                    />
                                )
                                )
                    }
                </FormPaper>
            </div>
        </div>
    )
}

export default KeystrokeHistory;